// Mock data for selectors
export const genderOptions = [
  { value: "MALE", label: "Male", arabic_label: "ذكر" },
  { value: "FEMALE", label: "Female", arabic_label: "أنثى" },
];

export const vacancyLangOptions = [
  { value: "EN", label: "English", arabic_label: "إنجليزي" },
  { value: "AR", label: "Arabic", arabic_label: "عربي" },
  { value: "BOTH", label: "Both", arabic_label: "كلاهما" },
];

export const statusOptions = [
  { value: "ACTIVE", label: "Active", arabic_label: "نشط" },
  { value: "INACTIVE", label: "Inactive", arabic_label: "غير نشط" },
  { value: "ONLINE", label: "Online", arabic_label: "متاح" },
  { value: "PENDING", label: "Pending", arabic_label: "قيد الانتظار" },
  { value: "EXPIRED", label: "Expired", arabic_label: "منتهي الصلاحية" },
];

export const salaryTypeOptions = [
  { value: "SALARY_SCALE", label: "Salary Scale", arabic_label: "سلم رواتب" },
  {
    value: "AFTER_THE_INTERVIEW",
    label: "After Interview",
    arabic_label: "بعد المقابلة",
  },
  { value: "RANGE", label: "Range", arabic_label: "نطاق" },
  { value: "FIXED", label: "Fixed", arabic_label: "ثابت" },
];

export const militaryServiceOptions = [
  { value: "NOT_FINISHED", label: "Not Finished", arabic_label: "غير مكتمل" },
  { value: "FINISHED", label: "Finished", arabic_label: "مكتمل" },
  { value: "EXEMPTED", label: "Exempted", arabic_label: "معفى" },
];

// Mock initial data
export const mockVacancyProfile = {
  user_id: null,
  job_type_id: null,
  degree_type_id: null,
  job_activity_ids: [],
  title: "",
  company_description: "",
  hide_company_name: false,
  email: "",
  employees_total_numbers: "",
  duration: "",
  heats: false,
  country_id: 19,
  city_id: 20,
  responsibilities: "",
  qualifications: "",
  additional_req: "",
  benefits: "",
  gender: "MALE",
  military_service: "FINISHED",
  photo: false,
  cv_lang: "EN",
  vacancy_lang: "EN",
  status: "ACTIVE",
  expiration_date: "",
  requirements_pdf: null,
  details_pdf: null,
  external_url: "",
  job_of_day: false,
  salary_type: "SALARY_SCALE",
  salary_type_meta: {
    value: "",
    start_range: "",
    end_range: "",
  },
  vip_company: false,
  best_place: false,
};

export const vacancyResumeLangOptions = [
  { value: "EN", label: "English", arabic_label: "إنجليزي" },
  { value: "AR", label: "Arabic", arabic_label: "عربي" },
  { value: "BOTH", label: "Both", arabic_label: "كلاهما" },
];
